module.exports = __webpack_public_path__ + "static/media/logo_fontana_bar.75da9419.png";